@if (signatureData$ | async; as signatureData) {
  <div>
    <p class="text-center">
      Bitte unterschreiben Sie im nachfolgenden Unterschriftenfeld, damit Ihr Antrag
      zur {{ getInsuranceTranslation(signatureData.servoProductName) }}-Versicherung gültig ist.
      <br />

      Ihren Antrag können Sie
      <a
        tabindex="0"
        (click)="downloadDocument(signatureData.servoContractId)"
        (keyup)="downloadDocument(signatureData.servoContractId)">hier</a>
      nochmals herunterladen.
    </p>

    <app-signature-pad
      (signingFinished)="signatureBase64 = $event"></app-signature-pad>

    @if (showSignatureInvalidError) {
      <div class="signature-invalid-error">
        Bitte unterschreiben Sie im grün umrandeten Feld.
      </div>
    }

    <div class="signature-infos">
      <span>{{ signatureData.publicPerson?.publicAddressDto?.city }}, am {{ currentDate | date:'dd.MM.yyyy' }}</span>

      <button
        [disabled]="isLoading"
        (click)="submit(signatureData.servoContractId)"
        class="btn btn-sm btn-success">

        @if (isLoading) {
          <span
            class="spinner-grow spinner-grow-sm me-2"
            aria-hidden="true"></span>
          <span role="status">Antrag wird unterzeichnet</span>
        } @else {
          <span>Antrag unterzeichnen</span>
        }
      </button>
    </div>
  </div>

}

@if (showError) {
  <div class="alert alert-danger text-center">
    Dieser Link ist ungültig oder der Antrag wurde bereits signiert.
  </div>
}
